export enum AddionalInfo {
    Github = "https://github.com/igorrfc",
    Linkedin = "https://www.linkedin.com/in/igor-fernandes-25760bb9/",
    Resume = "https://drive.google.com/drive/folders/1IPGxj1CfYt8BxaUcO-ii7_9WLLNF0Tdf?usp=sharing"
}
